import { createFileRoute } from '@tanstack/react-router'

import { CustomerSummary } from '@/features/evaluations/customer-summary'

/** The customer-facing summary of an evaluation, without the internal numbers. */
export const Route = createFileRoute('/_print/evaluations/$evaluationId/summary')({
  component: SummaryRoute,
})

function SummaryRoute() {
  const { evaluationId } = Route.useParams()
  return <CustomerSummary evaluationId={evaluationId} />
}
